import React from "react";
import { Link, Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import TelegramShowcase from "../components/TelegramShowcase";
import PublicHeader from "../components/PublicHeader";
import { ArrowRight, LogIn, UserPlus, Building2 } from "lucide-react";

export default function Home() {
  const { user, ready } = useAuth();

  // Hub privato: se sei loggato vai dritto al menu
  if (ready && user) return <Navigate to="/menu" replace />;

  return (
    <div className="min-h-screen bg-background bg-grain flex flex-col">
      <PublicHeader />

      <main className="flex-1 animate-fade-in flex items-center">
        <div className="w-full max-w-3xl mx-auto px-4 sm:px-8 py-16 sm:py-24">
          <div className="text-xs uppercase tracking-[0.25em] text-muted-foreground font-semibold mb-4 flex items-center gap-2">
            <span className="inline-block w-1.5 h-1.5 rounded-full bg-primary animate-pulse"></span>
            Servizio interno per uffici
          </div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1.05] mb-6">
            Il pranzo dell'ufficio,
            <br />
            <span className="text-accent">organizzato bene.</span>
          </h1>
          <p className="text-lg sm:text-xl text-muted-foreground leading-relaxed mb-10 max-w-2xl">
            I colleghi che cucinano pubblicano il menu del giorno. Tu prenoti in due tap dal web
            o dal bot Telegram. Niente WhatsApp, niente foglietti, niente "ti devo cinque euro".
          </p>

          <div className="grid sm:grid-cols-2 gap-4 mb-10">
            <Link
              to="/login"
              data-testid="home-cta-login"
              className="group bg-card border border-border rounded-lg p-6 hover:border-foreground/30 hover:shadow-sm transition-all"
            >
              <div className="w-10 h-10 rounded-md bg-primary/10 text-primary flex items-center justify-center mb-3">
                <LogIn className="w-5 h-5" />
              </div>
              <div className="font-display font-medium text-lg mb-1">Accedi</div>
              <p className="text-sm text-muted-foreground mb-2">
                Sei già registrato? Entra e prenota il pranzo di oggi.
              </p>
              <span className="text-sm text-primary font-medium inline-flex items-center gap-1 group-hover:gap-2 transition-all">
                Vai al login <ArrowRight className="w-3.5 h-3.5" />
              </span>
            </Link>

            <Link
              to="/register"
              data-testid="home-cta-register"
              className="group bg-card border border-border rounded-lg p-6 hover:border-foreground/30 hover:shadow-sm transition-all"
            >
              <div className="w-10 h-10 rounded-md bg-primary/10 text-primary flex items-center justify-center mb-3">
                <UserPlus className="w-5 h-5" />
              </div>
              <div className="font-display font-medium text-lg mb-1">Registrati</div>
              <p className="text-sm text-muted-foreground mb-2">
                Il tuo ufficio è già attivo? Crea l'account con la tua email di lavoro.
              </p>
              <span className="text-sm text-primary font-medium inline-flex items-center gap-1 group-hover:gap-2 transition-all">
                Crea account <ArrowRight className="w-3.5 h-3.5" />
              </span>
            </Link>
          </div>

          {/* Pitch per altri uffici: sobrio, una sola riga + CTA */}
          <div
            className="bg-primary/5 border border-primary/20 rounded-lg p-5 sm:p-6 flex items-start sm:items-center gap-4 flex-col sm:flex-row"
            data-testid="home-pitch-other-offices"
          >
            <div className="w-10 h-10 rounded-md bg-primary/15 text-primary flex items-center justify-center shrink-0">
              <Building2 className="w-5 h-5" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-display font-medium text-base mb-0.5">
                Vuoi portare Schiscetta nel tuo ufficio?
              </div>
              <p className="text-sm text-muted-foreground">
                Funziona ovunque ci siano colleghi che cucinano e colleghi che vogliono pranzare meglio.
              </p>
            </div>
            <Link
              to="/pricing"
              data-testid="home-cta-contact"
              className="shrink-0 px-4 py-2 bg-primary text-white text-sm font-medium rounded-md hover:bg-[#436343] active:scale-[0.98] transition-all inline-flex items-center gap-1.5"
            >
              Vedi i piani <ArrowRight className="w-3.5 h-3.5" />
            </Link>
          </div>

          <div className="mt-10 text-sm flex items-center gap-5">
            <Link to="/guida" data-testid="home-link-guida" className="text-primary hover:underline">
              Guida rapida per nuovi utenti →
            </Link>
            <Link to="/info" data-testid="home-link-info" className="text-muted-foreground hover:text-primary transition-colors">
              Leggi il manifesto
            </Link>
          </div>
        </div>
      </main>

      <TelegramShowcase />

      <footer className="border-t border-border py-6">
        <div className="max-w-5xl mx-auto px-4 sm:px-8 text-center text-xs text-muted-foreground">
          Schiscetta · piattaforma interna per uffici · 2026
        </div>
      </footer>
    </div>
  );
}
